const state = {
  dangerList: [],
  loading: true,
  openTab:[],//所有打开的路由
  activeIndex:'/processManager' , //默认激活路径；激活状态
  cameraInfo: {}
}

export default state